module.exports = __webpack_public_path__ + "img/contanctTwo.7ada13ae.png";